import { useTiendaInfo } from "../../contexts/TiendaInfoContext";

export default function StoreInfo() {
  const tiendaInfo = useTiendaInfo();
  const storeName = tiendaInfo?.nombreTienda ?? "Semillando";
  const address = tiendaInfo?.direccionLinea1 ?? "";
  const schedule = tiendaInfo?.direccionLinea2 ?? "";

  if (!address) return null;

  return (
    <div
      style={{
        padding: "14px 16px",
        borderRadius: 16,
        background: "rgba(10,10,10,0.03)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 14,
      }}
    >
      <div>
        <div style={{ fontSize: 13, fontWeight: 500 }}>{`${storeName} · ${address}`}</div>
        {schedule && (
          <div style={{ fontSize: 11.5, color: "var(--ink-500)", marginTop: 2 }}>
            {schedule}
          </div>
        )}
      </div>
      <span
        style={{
          padding: "6px 12px",
          borderRadius: 999,
          background: "var(--ink-900)",
          color: "var(--cream-50)",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.08em",
        }}
      >
        GRATIS
      </span>
    </div>
  );
}
